import { render, staticRenderFns } from "./PreviousMeetingsWidget.vue?vue&type=template&id=d9bcc354&scoped=true"
import script from "./PreviousMeetingsWidget.vue?vue&type=script&lang=js"
export * from "./PreviousMeetingsWidget.vue?vue&type=script&lang=js"
import style0 from "./PreviousMeetingsWidget.vue?vue&type=style&index=0&id=d9bcc354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9bcc354",
  null
  
)

export default component.exports